/* ==========================================================================
   ALBEUX NAV SPEED (1 Nov 2026): product pages and collection pages open at once.
   What it does: the page a customer is about to open is fetched quietly BEFORE the tap, so the tap only has to show it.
   1. Product and collection links that are on screen (collection grids, You may also like, the home tiles, the menu once it is open) are fetched in the background,
      one at a time, a moment after the page has finished loading. At most 14 pages per visit, so a phone is never flooded.
   2. The instant a finger goes down on a link (or the mouse rests on it for a fraction of a second) that page is fetched straight away, ahead of everything else.
   3. Customers who use Data Saver or a very slow connection are left alone: nothing is fetched for them.
   Only the safe "prefetch" is used (the page text is fetched, the page is NOT pre-drawn), so no page can ever wake up half started.
   Browsers that understand speculation rules (Chrome, Edge, Android) use them; the others get a plain prefetch link.
   It changes nothing that can be seen: no look, no font, no colour, no layout.
   To switch it off, delete the albeux-nav-speed.js line in snippets/albeux-fixes.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__albeuxNav) return;
  window.__albeuxNav = true;

  var nav = navigator;
  var conn = nav.connection || nav.mozConnection || nav.webkitConnection || {};
  if (conn.saveData) return;
  if (/(^|-)2g$/.test(conn.effectiveType || '')) return;
  try { if (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches) return; } catch (e) {}

  var VIEW_MAX = 14;   /* pages fetched ahead from what is on screen, per visit */
  var INTENT_MAX = 60; /* pages fetched because a finger or mouse went to them */
  var PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:products|collections)(?:\/|$)/i;
  var CARD = '.product-grid__item, .resource-list__item, .collection-card, .albeux-coll__card, .albeux-feature__tile, product-card, .product-card';

  var done = Object.create(null);
  var total = 0;
  var viewCount = 0;
  var queue = [];
  var busy = false;
  var loaded = document.readyState === 'complete';
  var canSpec = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));

  /* The address worth fetching for a link, or '' when the link is not one we should touch */
  function urlOf(a) {
    try {
      if (!a || !a.href) return '';
      if (a.origin !== location.origin) return '';
      if (a.target && a.target !== '_self') return '';
      if (a.hasAttribute('download') || a.hasAttribute('data-no-prefetch')) return '';
      if (!PATH.test(a.pathname)) return '';
      var u = a.origin + a.pathname + a.search;
      if (u === location.origin + location.pathname + location.search) return '';
      return u;
    } catch (e) { return ''; }
  }

  function warm(u, intent) {
    if (!u || done[u]) return;
    if (intent ? total >= INTENT_MAX : viewCount >= VIEW_MAX) return;
    done[u] = true;
    total++;
    if (!intent) viewCount++;
    try {
      if (canSpec) {
        var s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [u], eagerness: 'immediate' }] });
        document.head.appendChild(s);
      } else {
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.as = 'document';
        l.href = u;
        document.head.appendChild(l);
      }
    } catch (e) {}
  }

  /* ---------- 1. Pages that are on screen are fetched quietly, one at a time ---------- */
  function idle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 }); else setTimeout(fn, 300);
  }

  function pump() {
    if (busy || !loaded) return;
    busy = true;
    idle(function next() {
      if (!queue.length || viewCount >= VIEW_MAX || document.hidden) { busy = false; return; }
      warm(queue.shift(), false);
      setTimeout(function () { idle(next); }, 180);
    });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var t = en.target;
      if (en.isIntersecting) {
        /* It must stay in view for a moment: a link that only flashes past while scrolling is not worth fetching */
        t.__albT = setTimeout(function () {
          var u = urlOf(t.__albA);
          if (u && !done[u] && queue.indexOf(u) < 0) { queue.push(u); pump(); }
          io.unobserve(t);
        }, 350);
      } else {
        clearTimeout(t.__albT);
      }
    });
  }, { threshold: 0.35 }) : null;

  function scan() {
    if (!io) return;
    var list = document.querySelectorAll('a[href*="/products/"]:not([data-alb-nav]), a[href*="/collections/"]:not([data-alb-nav])');
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      a.setAttribute('data-alb-nav', '1');
      /* Links with a query (filters, sorting) are never fetched ahead of time */
      if (!urlOf(a) || a.search) continue;
      var t = (a.closest && a.closest(CARD)) || a;
      t.__albA = a;
      io.observe(t);
    }
  }

  /* ---------- 2. Intent: a finger down or a resting mouse fetches that page at once ---------- */
  function linkOf(e) {
    var t = e.target;
    return t && t.closest ? t.closest('a[href]') : null;
  }
  function onDown(e) { warm(urlOf(linkOf(e)), true); }
  document.addEventListener('pointerdown', onDown, { passive: true, capture: true });
  document.addEventListener('touchstart', onDown, { passive: true, capture: true });

  var hoverTimer = 0;
  document.addEventListener('mouseover', function (e) {
    var a = linkOf(e);
    if (!a) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { warm(urlOf(a), true); }, 60);
  }, { passive: true });
  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true });

  /* ---------- Start-up and keeping up with new tiles (filters, infinite scroll, menu) ---------- */
  function start() {
    scan();
  }
  function onLoaded() {
    loaded = true;
    scan();
    pump();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  if (loaded) pump(); else window.addEventListener('load', onLoaded, { once: true });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) pump(); });

  if ('MutationObserver' in window) {
    var queued = 0;
    new MutationObserver(function () {
      if (queued) return;
      queued = setTimeout(function () { queued = 0; scan(); }, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
